export const GEO_TYPES = ['coordinates', 'polygon'];
